import ArrowRightSquareIcon from "@/assets/icons/arrow-right-square-icon.svg";
import AwardIcon from "@/assets/icons/award-icon.svg";
import BankIcon from "@/assets/icons/bank-icon.svg";
import BarsIcon from "@/assets/icons/bars-icon.svg";
import BillIcon from "@/assets/icons/bill-icon.svg";
import CardsIcon from "@/assets/icons/cards-icon.svg";
import CreditCardIcon from "@/assets/icons/creditCard-icon.svg";
import DashboardIcon from "@/assets/icons/dashboard-icon.svg";
import DatabaseIcon from "@/assets/icons/database-icon.svg";
import EditIcon from "@/assets/icons/edit-icon.svg";
import ExcelIcon from "@/assets/icons/excel.svg";
import FolderIcon from "@/assets/icons/folder-icon.svg";
import GoldIcon from "@/assets/icons/gold-icon.svg";
import IdcardIcon from "@/assets/icons/idcard-icon.svg";
import InboxIcon from "@/assets/icons/inbox-icon.svg";
import MoneyIcon from "@/assets/icons/money-icon.svg";
import Note2Icon from "@/assets/icons/note-2-icon.svg";
import PeopleIcon from "@/assets/icons/people-icon.svg";
import PercentageIcon from "@/assets/icons/percentage-icon.svg";
import ProfileCircleIcon from "@/assets/icons/profile-circle-icon.svg";
import ReportIcon from "@/assets/icons/report-icon.svg";
import SettingIcon from "@/assets/icons/setting-icon.svg";
import StoreIcon from "@/assets/icons/store-icon.svg";
import TableTextIcon from "@/assets/icons/table-text-icon.svg";
import TeamIcon from "@/assets/icons/team-icon.svg";
import TrophyIcon from "@/assets/icons/trophy-icon.svg";
import UserThickIcon from "@/assets/icons/user-thick-icon.svg";
import UsersIcon from "@/assets/icons/users-icon.svg";
import WalletIcon from "@/assets/icons/wallet-icon.svg";

export const icons = {
	"dashboard-icon": DashboardIcon,
	"store-icon": StoreIcon,
	"team-icon": TeamIcon,
	"bars-icon": BarsIcon,
	"inbox-icon": InboxIcon,
	"gold-icon": GoldIcon,
	"idcard-icon": IdcardIcon,
	"trophy-icon": TrophyIcon,
	"creditCard-icon": CreditCardIcon,
	"percentage-icon": PercentageIcon,
	"database-icon": DatabaseIcon,
	"report-icon": ReportIcon,

	"excel-icon": ExcelIcon,
	"people-icon": PeopleIcon,
	"bank-icon": BankIcon,
	"bill-icon": BillIcon,
	"money-icon": MoneyIcon,
	"profile-circle-icon": ProfileCircleIcon,
	"table-text-icon": TableTextIcon,
	"user-thick-icon": UserThickIcon,
	"wallet-icon": WalletIcon,
	"arrow-right-square": ArrowRightSquareIcon,
	"users-icon": UsersIcon,
	"folder-icon": FolderIcon,
	"award-icon": AwardIcon,
	"cards-icon": CardsIcon,
	"note-2-icon": Note2Icon,
	"setting-icon": SettingIcon,
	"edit-icon": EditIcon,
};

export type IconPath = keyof typeof icons;
